// extracted by mini-css-extract-plugin
export default {"front":"front_front__a1Pet","main-content":"front_main-content__dwz6K","footer":"front_footer__+etkp"};